<template functional>
  <v-card flat
    :to="{name: 'NewsView', params:{newsId: props.p.id}}"
  >
    <div style="padding:10px 5px;border-bottom: 1px solid #ddd;">
      <v-layout row wrap>
        <v-flex xs9 sm10>
          <p class="newsTitle">{{props.p.title}}</p>
          <p class="newsSiteName">
            {{props.p.sitename}}
            <span class="newsDate">{{props.dateStr}}</span>
          </p>
        </v-flex>
        <v-flex xs3 sm2>
          <div style="">
            <v-img
              v-lazy:background-image=props.p.imageurl
              height="100px"
              class="newsImage"
            ></v-img>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    p: Object
  },
  
}
</script>

<style scoped>
  p {
    margin: 0;
    padding: 0;
  }
  .newsTitle{
    font-size:12pt;
    font-weight: bold;
    margin-bottom:10px;
    height:50px;
    overflow: hidden
  }
  .newsSiteName{
    color:#666;
    font-size:11pt;
  }
  .newsDate {
    margin-left: 10px;
    font-size:10pt;
  }
  .newsImage[lazy='loaded'] {
    background-size:cover;
  }
</style>